export const suggestionTypes = {
  LOW_CONTRAST: 1,
  LOW_RESOLUTION: 2
};

export const statusValues = {
  RESOLVED: 1,
  UNRESOLVED: 0
};
